import type { ContentTypeOptions } from '@mfw/common';

import type { FetchPremiumCatalogArgs } from '../api/types/premiumContent.types';

import { createQueryKeys } from '@lukemorales/query-key-factory';

import { fetchPremiumCatalog } from '../api/premiumContent.api';

export const premiumContentQueryKeys = createQueryKeys('premiumContent', {
  fetchInfiniteCatalog: ({
    contentType,
    favoritesOnly,
    search,
    tableFilters,
  }: FetchPremiumCatalogArgs) => ({
    queryFn: async (context: any) => {
      return fetchPremiumCatalog({
        contentType,
        favoritesOnly,
        search,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
      });
    },
    queryKey: [contentType, favoritesOnly, search, tableFilters],
  }),
  fetchItemByContent: ({
    contentId,
    contentType,
    organizationId,
  }: {
    contentId: string;
    contentType: ContentTypeOptions;
    organizationId?: string;
  }) => ({
    queryFn: async () => {
      const response = await fetchPremiumCatalog({
        contentId,
        contentType: [contentType],
        organizationId,
        tableFilters: { limit: '1' },
      });
      return response?.data[0] ?? null;
    },
    queryKey: [contentId, contentType, organizationId],
  }),
});
